import OurMissionImage from "../../../assets/images/OurMission.png";
import { ReactComponent as ShieldIcon } from "../../../assets/icons/ShieldIcon.svg";

const OurMission = () => {
  return (
    <section
      // className="plan"
      // style={{ backgroundImage: `url(${BlueBgImage})` }}
      className=" plan section-bg section-bg--white"
    >
      <div className="plan__container">
        {/* LEFT CONTENT */}
        <div className="plan__image-wrap">
          <img src={OurMissionImage} alt="Our Mission" />
        </div>
        {/* RIGHT IMAGE */}
        <div className="plan__content">
          <h4 className="primary">
            OUR MISSION
            <div className="divider" />
          </h4>
          <div className="content primary">
            To provide families with children in independent schools the
            financial security and peace of mind that their children's education
            will continue — uninterrupted — <span className="content-medium primary">even when life brings its most
            difficult challenges.</span>
          </div>
          <div className="content primary">
           We deliver specialist, empathetic
            fee-protection advice built on responsible financial planning, deep
            sector knowledge, and a genuine <span className="content-medium primary">commitment to continuity of
            education and family resilience.</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurMission;
